"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAd = updateAd;
async function updateAd(advertisingRepo, adId, payload) {
    return advertisingRepo.updateAd(adId, payload);
}
